import styleTextInput from '../../../../../shared/components/rbh-textinput/styles';
import React, { useEffect, useRef, useState } from 'react';
import {
  RBHAutoComplete,
  RBHBox,
  RBHButton,
  RBHDatePicker,
  RBHImage,
  RBHRadio,
  RBHSelect,
  RBHText,
  RBHTextInput,
  RBHTextInputArea,
} from '../../../../../shared/components';
import { ConfigProvider, Form, Radio, Row, Select, Space } from 'antd';
import moment from 'moment';
import numeral from 'numeral';
import 'moment/locale/th';
import Modal from 'antd/lib/modal/Modal';
import { Images } from '../../../../../shared/theme';
import styleButton from '../../../../../shared/components/rbh-button/styles';
import styleText from '../../../../../shared/components/rbh-text/styles';
import styleModal from '../../../../../shared/components/rbh-modal/styles';
import { Branch } from '../../../../../shared/models/branch';
import { FormattedMessage } from 'react-intl';
import { BranchValidator, CommonValidator, ShopValidator } from '@ppvrbh/merchant-core';
import { httpCreators } from '@ppvrbh/merchant-frontend-core';
import styles, { layout, StyleWrapper } from './styles';
import './stylescss.css';
import options from '../../../../../shared/resources/zipcode/province.min.json';
import { MainHelper } from '../../../../main-helper';
import {
  BRANCH_REQUEST_ID_LIST,
} from '../../redux/branch-constant';
import { branchSagas } from '../../redux/branch-saga';
import { BranchService } from '../../redux/branch-service';
import { useDispatch, useSelector } from 'react-redux';
import { crop } from '../../../../../shared/helpers/crop';
import {
  GoogleMap,
  Marker,
  withGoogleMap,
  withScriptjs,
} from 'react-google-maps';
import { useHistory } from 'react-router';
import { envConfig } from '../../../../../config';
import { MAIN_STATE_KEY, mainStateSelector } from '../../../../main-reducer';
import { BUSINESS_TYPE, SQC_STATUS } from '../../../../main-constant';
import { GENERAL_STATE_KEY, generalStateSelector } from '../../../../../redux/general/general-reducer';
import { Locale } from '../../../../../language';
import locale from 'antd/lib/locale/en_US';
import { DATE_TIME_FORMAT_NO_TZ, DAYS_OPTION, TIME_24 } from '../../../../../shared/helpers/constant';
import { UtilHelper } from '../../../../../shared/helpers/utility';
import { AuthHelper } from '../../../../../auth/auth-helper';
import { OpenHourFormItem } from './OpenHourFormItem';

const { Option } = Select;

const getFloatPosition = (position: any) => {
  return { lat: parseFloat(position.lat), lng: parseFloat(position.lng) };
};

const MapWithAMarker = withScriptjs(
  withGoogleMap((props: any) => (
    <GoogleMap
      defaultZoom={16}
      defaultCenter={getFloatPosition(props.position)}
    >
      <Marker
        position={getFloatPosition(props.position)}
        draggable={true}
        onDragEnd={props.onDrag}
      />
    </GoogleMap>
  ))
);

export const FormAddEdit: React.FC<Props> = (p) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const businessTypeId = AuthHelper.getBusinessTypeId();
  let branch;
  if (p.editData) {
    branch = new Branch(p.editData);
  }

  const [formInvalid, setFormInvalid] = useState(branch ? false : true);
  const [shopId] = useState(branch ? branch.shopId : undefined);
  const [position, setPosition] = useState({
    lat: branch ? (branch.shopLatitude as string) : '13.75669520',
    lng: branch ? (branch.shopLongitude as string) : '100.50150020',
  });
  const [lastPosition, setLastPosition] = useState({ lat: '0', lng: '0' });

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((pos: any) => {
      if (!p.editData) {
        setPosition({
          lat: getLatLng8DecimalPlaces(pos.coords.latitude),
          lng: getLatLng8DecimalPlaces(pos.coords.longitude),
        });
      }
    });
    return () => {
      if (history.action === 'POP' && p.editData) {
        history.push('/main/branchmanagement');
      }
    };
  }, [navigator, history]);

  const [form] = Form.useForm();
  const branchOpenHourStatusCode =
    MainHelper.getMasterDataByScheme('OpenHourStatus');
  const masterdata = useSelector(mainStateSelector(MAIN_STATE_KEY.MASTER_DATA));
  const currentLang = useSelector(generalStateSelector(GENERAL_STATE_KEY.LOCALE));
  const [subdistrict, setSubdistrict] = useState(
    branch ? branch.address.addressSubdistrict : ''
  );
  const [district] = useState('');
  const [province] = useState('');
  const [zipcode, setZipcode] = useState(
    branch ? branch.address.addressPostalCode : ''
  );
  const [visible, setVisible] = useState(false);
  const [tempCloseShopVisible, setTempCloseShopVisible] = useState(
    branch ? branch.shopStatus === 'SS02' : false
  );
  const [isBatchTimePeriod] = React.useState(
    branch ? branch.isBatchTimePeriod : false
  );
  const [radioValue, setRadioValue] = useState(
    branch
      ? branch.scheduleType === null
        ? undefined
        : branch.scheduleType
      : undefined
  );
  const [date, setDate] = useState(
    branch ? branch.nextOpenDateTime : undefined
  );
  const [maximumCloseDay] = useState(
    branch ? branch.maximumCloseDay : undefined
  );
  const inputRef = useRef<any>(null);
  const inputCoverRef = useRef<any>(null);
  const [lastFile, setLastFile] = useState(undefined);
  const [lastCoverFile, setLastCoverFile] = useState(undefined);
  const [imageUpload, setImageUpload] = useState(
    branch ? branch.shopPhoto : null
  );
  const [coverImageUpload, setCoverImageUpload] = useState(
    branch ? branch.shopCover : null
  );

  const transformOpenHourData = (index: number, branch?: Branch) => {
    if (!branch || !branch.openHours[index]) {
      return {
        isOpen: true,
        openHour: undefined,
        closeHour: undefined,
        applyAllDay: false
      }
    }
    const item = branch.openHours[index]
    const isOpen = item.openHourStatus === branchOpenHourStatusCode[0]
    return {
      isOpen,
      openHour: item.openHour.substring(0, 5),
      closeHour: item.closeHour.substring(0, 5),
      applyAllDay: isOpen && item.closeHour === item.openHour
    }
  }

  const [openHours, setOpenHours] = useState([
    {
      weekdayId: 1,
      dayName: 'main.branchform.sunday',
      ...transformOpenHourData(0, branch),
    },
    {
      weekdayId: 2,
      dayName: 'main.branchform.monday',
      ...transformOpenHourData(1, branch),
    },
    {
      weekdayId: 3,
      dayName: 'main.branchform.tuesday',
      ...transformOpenHourData(2, branch),
    },
    {
      weekdayId: 4,
      dayName: 'main.branchform.wednesday',
      ...transformOpenHourData(3, branch),
    },
    {
      weekdayId: 5,
      dayName: 'main.branchform.thursday',
      ...transformOpenHourData(4, branch),
    },
    {
      weekdayId: 6,
      dayName: 'main.branchform.friday',
      ...transformOpenHourData(5, branch),
    },
    {
      weekdayId: 7,
      dayName: 'main.branchform.saturday',
      ...transformOpenHourData(6, branch),
    },
  ])

  const showRemarkByShopQCStatus = (shopQCStatus: string) => {
    return (
      shopQCStatus !== SQC_STATUS.SQC_APPROVE &&
      shopQCStatus !== SQC_STATUS.SQC_PENDING_CAN_SELL
    );
  };

  // return true means data is invalid
  const checkTimeInvalid = () => {
    return openHours.some(item => {
      if (!item.isOpen || item.applyAllDay) {
        return false;
      }

      return item.openHour === undefined || item.closeHour === undefined
    })
  };

  const getStatusOption = () => {
    const branchStatusCode = masterdata.schemes['ShopStatus'];
    if (branchStatusCode && branchStatusCode.length > 0) {
      return branchStatusCode.map((code: any, index: any) => {
        const branchStatusTH = masterdata.codes[code].classificationNameTh;
        const branchStatusEN = masterdata.codes[code].classificationNameEn;
        return (
          <Option
            id={`dropdown-shop-status-select-${index}`}
            data-testid={`dropdown-shop-status-select-${index}`}
            style={styleText.textRegular14}
            key={index}
            value={code}
          >
            {currentLang === Locale.EN ? branchStatusEN : branchStatusTH}
          </Option>
        );
      });
    }

    return null;
  };

  const onChangeZipcodeSubdistrict = (e: any) => {
    const newData = e.split(',');
    setZipcode(newData[3]);
    setSubdistrict(newData[0]);
  };

  const onSelect = (e: any) => {
    const newData = e.split(',');
    form.setFieldsValue({
      zipcode: newData[3],
      subdistrict: newData[0],
      district: newData[1],
      province: newData[2],
    });
  };

  const onBlur = () => {
    const zipcodeValue = form.getFieldValue('zipcode');
    const subdistrictValue = form.getFieldValue('subdistrict');
    if (zipcode !== zipcodeValue || subdistrict !== subdistrictValue) {
      form.setFieldsValue({
        zipcode: '',
        subdistrict: '',
        district: '',
        province: '',
      });
    }
    form.validateFields(['zipcode', 'subdistrict']);
  };

  const onShowModal = () => {
    setLastPosition(position);
    setVisible(true);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
    setPosition(lastPosition);
  };

  const getLatLng8DecimalPlaces = (num: number) => {
    const fixedNum = UtilHelper.toFixedNumberWithoutRound(num, 8);
    return numeral(fixedNum).format('0,0.00000000');
  };

  const dragPosition = (e: any) => {
    setPosition({
      lat: getLatLng8DecimalPlaces(e.latLng.lat()),
      lng: getLatLng8DecimalPlaces(e.latLng.lng()),
    });
  };

  const onFinish = (values: any) => {
    let closeShopSchedule;
    let checkDelete = false;
    if (p.editData) {
      if (isBatchTimePeriod) {
        if (
          values.tempCloseShopOptions === 'ONE_DAY' ||
          values.tempCloseShopOptions === 'SCHEDULE'
        ) {
          checkDelete = true;
        } else if (values.tempCloseShopOptions === 'NOT_SPECIFY') {
          closeShopSchedule = {};
        } else if (
          values.branchStatus === 'SS01' ||
          values.tempCloseShopOptions === 'NOT_SPECIFY' ||
          values.tempCloseShopOptions === 'ONE_DAY' ||
          values.tempCloseShopOptions === 'SCHEDULE'
        ) {
          checkDelete = true;
        }
      } else {
        if (values.tempCloseShopOptions === 'ONE_DAY') {
          const start = new Date();
          const end = new Date();
          end.setDate(end.getDate() + 1);
          closeShopSchedule = {
            startDate: moment(start).format(DATE_TIME_FORMAT_NO_TZ),
            endDate: moment(end).startOf('d').format(DATE_TIME_FORMAT_NO_TZ),
            scheduleType: 'ONE_DAY',
          };
        } else if (values.tempCloseShopOptions === 'SCHEDULE') {
          const start = new Date();
          closeShopSchedule = {
            startDate: moment(start).format(DATE_TIME_FORMAT_NO_TZ),
            endDate: date,
            scheduleType: 'SCHEDULE',
          };
        } else if (values.tempCloseShopOptions === 'NOT_SPECIFY') {
          closeShopSchedule = {};
        } else if (
          values.branchStatus === 'SS01' ||
          values.tempCloseShopOptions === 'NOT_SPECIFY' ||
          values.tempCloseShopOptions === 'ONE_DAY' ||
          values.tempCloseShopOptions === 'SCHEDULE'
        ) {
          checkDelete = true;
        }
      }
    }

    const data = {
      closeShopSchedule,
      shopName: values.shopName,
      shopDescription: values.description,
      shopPhoto: p.editData
        ? values.shopphoto.startsWith('https://') ||
          values.shopphoto.startsWith('http://') ||
          values.shopphoto === ''
          ? null
          : imageUpload
        : imageUpload,
      shopCover: p.editData
        ? values.shopcoverphoto?.startsWith('https://') ||
          values.shopcoverphoto?.startsWith('http://') ||
          values.shopcoverphoto === ''
          ? null
          : coverImageUpload
        : coverImageUpload,
      shopPhoneNo: values.shopPhoneNo,
      shopLatitude: position.lat,
      shopLongitude: position.lng,
      shopLandmark: values.shopLandmark,
      branchCode: values.branchCode,
      shopId: p.editData ? Number(shopId) : undefined,
      shopStatus: values.branchStatus,
      address: {
        addressDetail: values.address,
        addressSubdistrict: values.subdistrict,
        addressDistrict: values.district,
        addressProvince: values.province,
        addressPostalCode: values.zipcode,
      },
      openHours: openHours.map((item) => {
        const shouldForceDefault = !item.isOpen || item.applyAllDay;
        const defaultValue = '00:00';
        return {
          weekdayId: item.weekdayId,
          openHour: shouldForceDefault ? defaultValue : item.openHour,
          closeHour: shouldForceDefault ? defaultValue : item.closeHour,
          openHourStatus: item.isOpen ? branchOpenHourStatusCode[0] : branchOpenHourStatusCode[1]
        }
      })
    };

    if (!p.editData || checkDelete) {
      delete data.closeShopSchedule;
    }
    dispatch(
      httpCreators.request({
        id: p.editData
          ? BRANCH_REQUEST_ID_LIST.EDIT_BRANCH
          : BRANCH_REQUEST_ID_LIST.ADD_BRANCH,
        sagaHandler: p.editData
          ? (branchSagas.editBranchHandler as any)
          : (branchSagas.addBranchHandler as any),
        callbackParams: p.onSuccessCallback,
        service: p.editData
          ? BranchService.editBranch
          : businessTypeId === BUSINESS_TYPE.MART
          ? BranchService.addMartBranch
          : BranchService.addBranch,
        serviceParams: data,
      })
    );
  };

  const trimFieldValue = (fieldName: string) => {
    const value = form.getFieldValue(fieldName);

    if (value) {
      form.setFieldsValue({
        [fieldName]: value.trim(),
      });
      form.validateFields([fieldName]);
    }
  };

  const handleChangePhoto = (file: any) => {
    if (
      file.target.files[0] &&
      (file.target.files[0].type === 'image/png' ||
        file.target.files[0].type === 'image/jpeg')
    ) {
      setLastFile(file.target.files);
      crop(URL.createObjectURL(file.target.files[0]), 1).then((canvas: any) => {
        setImageUpload(canvas);
      });
    } else {
      if (lastFile) {
        inputRef.current.files = lastFile;
      } else {
        inputRef.current.value = '';
      }
    }
  };

  const handleChangeCoverPhoto = (file: any) => {
    if (
      file.target.files[0] &&
      (file.target.files[0].type === 'image/png' ||
        file.target.files[0].type === 'image/jpeg')
    ) {
      setLastCoverFile(file.target.files);
      crop(URL.createObjectURL(file.target.files[0]), 2).then((canvas: any) => {
        setCoverImageUpload(canvas);
      });
    } else {
      if (lastCoverFile) {
        inputCoverRef.current.files = lastCoverFile;
      } else {
        inputCoverRef.current.value = '';
      }
    }
  };

  const checkFormInvalid = () => {
    let invalid = false;

    const values = form.getFieldsValue();
    for (const key in values) {
      if (
        key === 'description' ||
        key === 'shopLandmark' ||
        key === 'branchCode' ||
        (key === 'shopphoto' && p.editData) ||
        key === 'shopcoverphoto'
      ) {
        // these fields are not required
      } else {
        if (values[key] === undefined || values[key] === '') {
          invalid = true;
          break;
        }
      }
    }

    if (!invalid) {
      const errors = form.getFieldsError();
      for (const field of errors) {
        if (field.errors.length > 0) {
          invalid = true;
          break;
        }
      }
    }

    setFormInvalid(invalid);
  };

  const dateStatusInvalid = openHours.every(item => !item.isOpen);

  const onChangeDate = (selectedDate: any) => {
    setDate(moment(selectedDate).startOf('d').format(DATE_TIME_FORMAT_NO_TZ));
  };

  const onChangeRadio = (e: any) => {
    setRadioValue(e.target.value);
  };

  const disabledDate = (current: any) => {
    const start = moment();
    const end = moment().add(maximumCloseDay, 'd');
    return current < start || current > end;
  };

  const textOptional = (id: string) => {
    return (
      <RBHBox style={{ display: 'flex' }}>
        <RBHText style={styleText.formText} text={id} />
        &nbsp;
        <RBHText
          style={styleText.textRegular14Gray}
          text={'main.form.text.optional'}
        />
      </RBHBox>
    );
  };

  const showShopStatusRemark = () => {
    return (
      <>
        {!p.editData ||
        (p.editData && showRemarkByShopQCStatus(p.editData?.shopQCStatus)) ? (
          <RBHBox style={styles.qcStatusRemark}>
            <RBHText
              data-testid={'shop-status-qc-remark'}
              id={'shop-status-qc-remark'}
              style={styles.light14fakeBlack}
              text={'main.branchtable.statusshop.qc.remark'}
            />
          </RBHBox>
        ) : null}
      </>
    );
  };

  return (
    <StyleWrapper>
      <Form
        size='large'
        onFieldsChange={checkFormInvalid}
        form={form}
        style={styleText.formText}
        labelCol={{ md: {span: 10} }}
        wrapperCol={{ md: {span: 16} }}
        onFinish={onFinish}
      >
        <Form.Item
          validateTrigger={['onChange', 'onBlur']}
          colon={false}
          name='shopName'
          label={<FormattedMessage id={'main.branchform.branchname'} />}
          initialValue={branch ? branch.shopName : undefined}
          rules={[
            {
              required: true,
              message: <FormattedMessage id={'main.form.required'} />,
            },
            {
              pattern: ShopValidator.shopName.regexPattern,
              message: <FormattedMessage id={'main.form.name.shop.valid'} />
            },
            { max: ShopValidator.shopName.maxLength, message: <FormattedMessage id='main.form.maxlength' /> }
          ]}>
          <RBHTextInput onBlur={() => trimFieldValue('shopName')} maxLength={ShopValidator.shopName.maxLength}
            style={styleTextInput.inputDefault} data-testid='shopName' id='shopName'
            placeholder={'main.branchform.addbranchname'} />
        </Form.Item>
        <Form.Item
          validateTrigger={['onChange', 'onBlur']}
          colon={false}
          name='branchCode'
          label={textOptional('main.branchform.branchid')}
          initialValue={branch ? branch.branchCode : undefined}
        >
          <RBHTextInput
            onBlur={() => trimFieldValue('branchCode')}
            style={styleTextInput.inputDefault}
            data-testid='branchCode'
            id='branchCode'
            maxLength={BranchValidator.branchCode.maxLength}
            placeholder={'main.branchform.addbranchid'}
          />
        </Form.Item>
        <Form.Item
          required={true}
          name='shopphoto'
          initialValue={branch ? branch.shopPhoto : undefined}
          colon={false}
          className='shop-photo-form-item'
          label={<FormattedMessage id={'main.branchform.shopphoto'} />}
        >
          <RBHBox>
            <Row justify='start' align='middle'>
              <Space className='image-box'  size={'small'}>
                <RBHBox style={styles.imageBox}>
                  <RBHImage
                    data-testid='image_upload'
                    id='image_upload'
                    name='image_upload'
                    style={imageUpload ? styles.imageStyle : styles.shopImageDefault}
                    src={imageUpload ?? Images.shopIcon}
                  />
                </RBHBox>
                <RBHBox className='upload-box' style={styles.uploadBox}>
                  <label data-testid='label-upload' id='label-upload'>
                    <input
                      ref={inputRef}
                      id='file-upload'
                      accept='image/png, image/jpeg, image/jpg'
                      type='file'
                      onChange={(e: any) => handleChangePhoto(e)}
                    />
                    <RBHBox className='upload-logo-input' style={styles.upload}>
                      <RBHText
                        data-testid='file-upload-text'
                        id='file-upload-text'
                        style={styleText.text16LightPurple}
                        text={'main.branchform.choosephoto'}
                      />
                    </RBHBox>
                  </label>
                </RBHBox>
              </Space>
            </Row>
            <RBHBox style={styles.paddingWarning}>
              <RBHText
                data-testid='text-photo-warning'
                id='text-photo-warning'
                style={styleText.textRegular14Gray}
                text={'main.branchform.warningphoto'}
              />
            </RBHBox>
          </RBHBox>
        </Form.Item>
        <Form.Item
          required={true}
          name='shopcoverphoto'
          initialValue={branch ? branch.shopCover : undefined}
          colon={false}
          label={<FormattedMessage id={'main.branchform.shopcoverphoto'} />}
        >
          <RBHBox>
            <Row justify='start' align='middle'>
              <Space className='image-box'  size={'middle'}>
                <RBHBox style={styles.coverImageBox}>
                   <RBHImage
                    data-testid='cover_image_upload'
                    id='cover_image_upload'
                    name='cover_image_upload'
                    style={coverImageUpload ? styles.imageStyle : styles.shopImageDefault}
                    src={coverImageUpload ?? Images.shopIcon}
                  />
                </RBHBox>
                <RBHBox className='upload-box' style={styles.uploadBox}>
                  <label
                    data-testid='label-cover-upload'
                    id='label-cover-upload'
                  >
                    <input
                      ref={inputCoverRef}
                      id='cover-file-upload'
                      accept='image/png, image/jpeg, image/jpg'
                      type='file'
                      onChange={(e: any) => handleChangeCoverPhoto(e)}
                    />
                    <RBHBox className='upload-cover-input' style={styles.upload}>
                      <RBHText
                        data-testid='cover-file-upload-text'
                        id='cover-file-upload-text'
                        style={styleText.text16LightPurple}
                        text={'main.branchform.choosephoto'}
                      />
                    </RBHBox>
                  </label>
                </RBHBox>
              </Space>
            </Row>
            <RBHBox style={styles.paddingWarning}>
              <RBHText
                data-testid='text-cover-photo-warning'
                id='text-cover-photo-warning'
                style={styleText.textRegular14Gray}
                text={'main.branchform.warningphoto'}
              />
            </RBHBox>
          </RBHBox>
        </Form.Item>
        <Form.Item
          initialValue={branch ? branch.shopDescription : undefined}
          colon={false}
          name='description'
          label={textOptional('main.branchform.description')}
          rules={[
            {
              max: BranchValidator.branchDescription.maxLength,
              message: <FormattedMessage id='main.form.maxlength' />,
            },
          ]}
        >
          <RBHTextInputArea
            data-testid='main.branchform.input.description'
            id='main.branchform.input.description'
            onBlur={() => trimFieldValue('description')}
            maxLength={BranchValidator.branchDescription.maxLength}
            placeholder={'main.branchform.adddescription'}
          />
        </Form.Item>
        <Form.Item
          validateTrigger={['onChange', 'onBlur']}
          colon={false}
          name='shopPhoneNo'
          label={<FormattedMessage id={'main.branchform.phone'} />}
          initialValue={branch ? branch.shopPhoneNo : undefined}
          rules={[
            {
              required: true,
              message: <FormattedMessage id={'main.form.required'} />,
            },
            {
              pattern: CommonValidator.PhoneNumber.regexPattern,
              message: (
                <FormattedMessage id={'main.inline.validate.phonenumber'} />
              ),
            },
          ]}
        >
          <RBHTextInput
            onBlur={() => trimFieldValue('shopPhoneNo')}
            maxLength={BranchValidator.branchPhone.maxLength}
            style={styleTextInput.inputDefault}
            data-testid='shopPhoneNo'
            id='shopPhoneNo'
            placeholder={'main.branchform.addphone'}
          />
        </Form.Item>
        <Form.Item
          validateTrigger={['onChange', 'onBlur']}
          colon={false}
          className='small-input'
          label={<FormattedMessage id={'main.branchform.address'} />}
          name='address'
          rules={[
            {
              required: true,
              message: <FormattedMessage id={'main.form.required'} />,
            },
            {
              pattern: BranchValidator.branchAddress.regexPattern,
              message: <FormattedMessage id={'main.form.text.valid'} />,
            },
          ]}
          initialValue={branch ? branch.address.addressDetail : undefined}
        >
          <RBHTextInput
            onBlur={() => trimFieldValue('address')}
            style={styleTextInput.inputDefault}
            data-testid='address'
            id='address'
            placeholder='main.branchform.addaddress'
            maxLength={BranchValidator.branchAddress.maxLength}
          />
        </Form.Item>

        <Form.Item colon={false} className='hide-small-label' label=' ' style={styles.marginBottom}>
          <Form.Item
            className='small-input'
            validateTrigger={['onChange', 'onBlur']}
            name='zipcode'
            style={styles.inlineBlock}
            rules={[
              {
                required: true,
                message: <FormattedMessage id={'main.form.required'} />,
              },
              {
                pattern: BranchValidator.branchZipcode.regexPattern,
                message: <FormattedMessage id={'main.form.digit.only'} />,
              },
            ]}
            initialValue={branch ? branch.address.addressPostalCode : ''}
          >
            <RBHAutoComplete
              data-testid='zipcode'
              id='zipcode'
              dropdownMatchSelectWidth={400}
              style={styleTextInput.inputWidth150}
              options={options}
              onChange={onChangeZipcodeSubdistrict}
              value={zipcode}
              placeholder='main.addzipcode'
              onSelect={onSelect}
              onBlur={onBlur}
              filterOption={true}
            />
          </Form.Item>
          <Form.Item
            validateTrigger={['onChange', 'onBlur']}
            className='small-input'
            name='subdistrict'
            style={styles.inlineBlock}
            rules={[
              {
                required: true,
                message: <FormattedMessage id={'main.form.required'} />,
              },
            ]}
            initialValue={branch ? branch.address.addressSubdistrict : ''}
          >
            <RBHAutoComplete
              data-testid='subdistrict'
              id='subdistrict'
              dropdownMatchSelectWidth={400}
              style={styleTextInput.inputWidth150}
              options={options}
              onChange={onChangeZipcodeSubdistrict}
              value={subdistrict}
              placeholder='main.addsubdistrict'
              onSelect={onSelect}
              onBlur={onBlur}
              filterOption={true}
            />
          </Form.Item>
        </Form.Item>
        <Form.Item colon={false} className='hide-small-label' label=' ' style={styles.marginBottom}>
          <Form.Item
            name='district'
            className='small-input'
            style={styles.inlineBlock}
            initialValue={branch ? branch.address.addressDistrict : undefined}
          >
            <RBHAutoComplete
              id='district  '
              data-testid='district'
              dropdownMatchSelectWidth={300}
              style={styleTextInput.inputWidth150}
              disabled={true}
              value={district}
              placeholder='main.adddistrict'
            />
          </Form.Item>
          <Form.Item
            name='province'
            className='small-input'
            style={styles.inlineBlock}
            initialValue={branch ? branch.address.addressProvince : undefined}
          >
            <RBHAutoComplete
              id='province'
              data-testid='province'
              dropdownMatchSelectWidth={300}
              style={styleTextInput.inputWidth150}
              disabled={true}
              value={province}
              placeholder='main.addprovince'
            />
          </Form.Item>
        </Form.Item>

        <Form.Item
          name='shopLandmark'
          colon={false}
          label={textOptional('main.branchform.landmark')}
          initialValue={branch ? branch.shopLandmark : undefined}
          rules={[
            {
              pattern: BranchValidator.branchLandmark.regexPattern,
              message: <FormattedMessage id={'main.form.text.valid'} />,
            },
          ]}
        >
          <RBHTextInputArea
            onBlur={() => trimFieldValue('shopLandmark')}
            data-testid='shopLandmark'
            id='shopLandmark'
            maxLength={BranchValidator.branchLandmark.maxLength}
            placeholder={'main.branchform.addlandmark'}
          />
        </Form.Item>
        <Form.Item
          colon={false}
          label={<FormattedMessage id={'main.branchform.pinmap.label'} />}
        >
          <RBHBox style={{ maxWidth: 500, maxHeight: 150, marginBottom: 8 }}>
            <img 
              src={
                `https://maps.googleapis.com/maps/api/staticmap?key=${envConfig.googleApiKey}&center=${position.lat},${position.lng}&zoom=16&scale=2&size=500x150&markers=color:red%7C${position.lat},${position.lng}`}
              alt="Map Preview"
              style={{ width: '100%', height: 'auto', display: 'block' }}
            />
          </RBHBox>
          <RBHButton
                data-testid={'map_pinning_button'}
                id={'map_pinning_button'}
                style={{
                  ...styleButton.buttonModalCancelGradient, 
                  maxWidth: 500,
                  width: '100%',
                }}
                onClick={onShowModal}
              >
            <FormattedMessage id={'main.branchform.pinmap.button'} />
          </RBHButton>
        </Form.Item>
        <Form.Item
          colon={false}
          label={<FormattedMessage id={'main.branchform.latlng.label'} />}
        >
          <RBHBox style={{ display: 'flex', flex: 1, maxWidth: 500 }}>
            <RBHTextInput
              value={position.lat}
              data-testid='shopLatitude'
              id='shopLatitude'
              disabled={true}
              placeholder={'main.branchform.lat'}
              style={{
                flex: 1,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0
              }}
            />
            <RBHTextInput
              value={position.lng}
              data-testid='shopLongitude'
              id='shopLongitude'
              disabled={true}
              placeholder={'main.branchform.lng'}
              style={{
                flex: 1,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0
              }}
            />
          </RBHBox>
        </Form.Item>

          {
            openHours.map((item, index) => (
              <Form.Item colon={false} label={index===0 ? <FormattedMessage id={'main.branchform.opendate'} />: ' '}>
                <OpenHourFormItem
                  dayName={item.dayName}
                  isOpen={item.isOpen}
                  startTime={item.openHour}
                  endTime={item.closeHour}
                  applyAllDay={item.applyAllDay}
                  onIsOpenChange={(value) => setOpenHours(prev => {
                    const newItem = [...prev]
                    newItem[index].isOpen = value;
                    return newItem
                  })}
                  onApplyAllDayChange={(value) => setOpenHours(prev => {
                    const newItem = [...prev]
                    newItem[index].applyAllDay = value;
                    return newItem
                  })}
                  onStartTimeChange={(value) => setOpenHours(prev => {
                    const newItem = [...prev]
                    newItem[index].openHour = value;
                    return newItem
                  })}
                  onEndTimeChange={(value) => setOpenHours(prev => {
                    const newItem = [...prev]
                    newItem[index].closeHour = value;
                    return newItem
                  })}
                />
              </Form.Item>
            ))
          }

        {masterdata && (
          <Form.Item
            extra={showShopStatusRemark()}
            colon={false}
            name='branchStatus'
            initialValue={branch ? branch.shopStatus : 'SS02'}
            rules={[{ required: true }]}
            label={<FormattedMessage id={'main.branchform.branchstatus'} />}
          >
            <RBHSelect
              onChange={(shopStatus: any) =>
                setTempCloseShopVisible(shopStatus === 'SS02')
              }
              data-testid={'dropdown-shop-status'}
              id={'dropdown-shop-status'}
            >
              {getStatusOption()}
            </RBHSelect>
          </Form.Item>
        )}

        {tempCloseShopVisible && p.editData ? (
          <Form.Item
            colon={false}
            name='tempCloseShopOptions'
            label=' '
            initialValue={radioValue}
          >
            <Radio.Group onChange={onChangeRadio}>
              <RBHRadio
                disabled={isBatchTimePeriod}
                data-testid={'option1'}
                id={'option1'}
                value={'ONE_DAY'}
                style={styles.regular14fakeBlack}
                textOption={'main.branchtable.statusshop.onlytoday'}
              />
              <RBHText
                disabled={isBatchTimePeriod}
                data-testid={'onlytodaydesc'}
                id={'onlytodaydesc'}
                style={styles.light14darkGray}
                text={'main.branchtable.statusshop.onlytodaydesc'}
              />

              <RBHRadio
                disabled={isBatchTimePeriod}
                data-testid={'option2'}
                id={'option2'}
                value={'SCHEDULE'}
                style={styles.regular14fakeBlack}
                textOption={'main.branchtable.statusshop.tempclose'}
              />
              <RBHText
                disabled={isBatchTimePeriod}
                data-testid={'tempclosedesc'}
                id={'tempclosedesc'}
                style={
                  radioValue === 'SCHEDULE'
                    ? styles.light14darkGrayNoPaDingBottom8
                    : styles.light14darkGray
                }
                text={'main.branchtable.statusshop.tempclosedesc'}
                values={{ date: maximumCloseDay }}
              />

              {radioValue === 'SCHEDULE' && p.editData ? (
                <RBHBox style={styles.calendarBox}>
                  <ConfigProvider locale={locale}>
                    <Form.Item
                      name='calendarInput'
                      label=' '
                      colon={false}
                      validateTrigger={['onChange', 'onBlur']}
                      rules={[
                        {
                          required: true,
                          message: (
                            <FormattedMessage
                              id={'main.branchtable.statusshop.tempclose.error'}
                            />
                          ),
                        },
                      ]}
                      initialValue={
                        branch
                          ? branch.nextOpenDateTime
                            ? moment(branch.nextOpenDateTime)
                            : undefined
                          : undefined
                      }
                      required={false}
                    >
                      <RBHDatePicker
                        name={'calendarInput'}
                        style={styles.calendarInput}
                        showToday={false}
                        data-testid={'calendarInput'}
                        id={'calendarInput'}
                        disabled={
                          radioValue
                            ? radioValue !== 'SCHEDULE' || isBatchTimePeriod
                            : false
                        }
                        format={'DD MMM YYYY'}
                        placeholder={
                          'main.branchtable.statusshop.tempclosecalendarplaceholder'
                        }
                        onChange={onChangeDate}
                        autoComplete='off'
                        disabledDate={disabledDate}
                      />
                    </Form.Item>
                  </ConfigProvider>
                </RBHBox>
              ) : null}

              <RBHRadio
                data-testid={'option3'}
                id={'option3'}
                value={'NOT_SPECIFY'}
                style={styles.regular14fakeBlack}
                textOption={'main.branchtable.statusshop.notspecify'}
              />
              <RBHText
                data-testid={'notspecifydesc'}
                id={'notspecifydesc'}
                style={styles.light14darkGrayNoPaDingBottom}
                text={'main.branchtable.statusshop.notspecifydesc'}
              />
            </Radio.Group>
          </Form.Item>
        ) : null}

        {tempCloseShopVisible && p.editData ? (
          <Form.Item colon={false} label=' '>
            <RBHBox style={{ paddingTop: 0 }}>
              <RBHText
                data-testid={'remark'}
                id={'remark'}
                style={styles.regular14fakeBlack}
                text={'main.branchtable.statusshop.remark'}
              />
              <RBHText
                data-testid={'remarkdesc1'}
                id={'remarkdesc1'}
                style={styles.light14fakeBlack}
                text={'main.branchtable.statusshop.remarkdesc1'}
              />
              <RBHText
                data-testid={'remarkdesc2'}
                id={'remarkdesc2'}
                style={styles.light14fakeBlack}
                text={'main.branchtable.statusshop.remarkdesc2'}
              />
            </RBHBox>
          </Form.Item>
        ) : null}
        <Row justify='center' align='middle'>
          <Space size={'small'}>
            <RBHButton
              text='main.branchform.cancel'
              data-testid={'button_cancel'}
              id='button_cancel'
              style={styleButton.buttonModalCancelGradient}
              type='primary'
              htmlType='button'
              onClick={p.onCancel}
            />
            {!branch ? (
              <RBHButton
                text='main.branchform.add'
                data-testid={'button_add'}
                id='button_add'
                style={styleButton.buttonModalConfirmGradient}
                type='primary'
                htmlType='submit'
                disabled={
                  checkTimeInvalid()
                    ? checkTimeInvalid()
                    : dateStatusInvalid
                    ? dateStatusInvalid
                    : formInvalid
                }
              />
            ) : null}
            {branch ? (
              <RBHButton
                text='main.branchform.save'
                data-testid={'button_save'}
                id='button_save'
                style={styleButton.buttonModalConfirmGradient}
                type='primary'
                htmlType='submit'
                disabled={
                  checkTimeInvalid()
                    ? checkTimeInvalid()
                    : dateStatusInvalid
                    ? dateStatusInvalid
                    : formInvalid
                }
              />
            ) : null}
          </Space>
        </Row>
      </Form>

      <Modal
        closable={false}
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        cancelText={null}
        footer={null}
      >
        <RBHBox style={styleModal.map}>
          <MapWithAMarker
            googleMapURL={
              'https://maps.googleapis.com/maps/api/js?key=' +
              envConfig.googleApiKey
            }
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: `400px` }} />}
            mapElement={<div style={{ height: `100%` }} />}
            position={position}
            onDrag={dragPosition}
          />
          <RBHBox style={{ height: '30px' }} />
          <Row key='modalMap' justify='end' align='middle'>
            <Space size={'middle'}>
              <RBHButton
                data-testid={'cancel_map'}
                id={'cancel_map'}
                style={styleButton.buttonModalCancelGradient}
                key='back'
                onClick={handleCancel}
              >
                <FormattedMessage id={'main.button_cancel'} />
              </RBHButton>
              <RBHButton
                data-testid={'confirm_map'}
                id={'confirm_map'}
                style={styleButton.buttonModalConfirmGradient}
                key='submit'
                type='primary'
                onClick={handleOk}
              >
                <FormattedMessage id={'main.branchform.choosemap'} />
              </RBHButton>
            </Space>
          </Row>
        </RBHBox>
      </Modal>
    </StyleWrapper>
  );
};

type Props = {
  onSuccessCallback?: any;
  onCancel?: any;
  editData?: any;
};
